import { useState, useEffect, useCallback } from "react";
import { apiClient } from "@/lib/api";
import { Plan } from "../types";

interface UsePlansReturn {
  plans: Plan[];
  loading: boolean;
  error: string | null;
  refetch: () => Promise<void>;
}

export function usePlans(): UsePlansReturn {
  const [plans, setPlans] = useState<Plan[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPlans = useCallback(async () => {
    try {
      setLoading(true);
      setError(null);

      const data = await apiClient.getPlans();
      setPlans(data.plans);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed to fetch plans");
      console.error("Error fetching plans:", err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPlans();
  }, [fetchPlans]);

  return {
    plans,
    loading,
    error,
    refetch: fetchPlans,
  };
}
